import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-tactical-black/90 backdrop-blur border-b border-tactical-border">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/images/COUP_logo2.png" alt="CounterScript" className="h-8 w-auto" />
          <span className="font-headline text-xl tracking-wider text-white">COUNTERSCRIPT HQ</span>
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className={`font-headline text-sm tracking-widest transition ${isActive('/') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}>
            HOME
          </Link>
          <Link to="/training" className={`font-headline text-sm tracking-widest transition ${isActive('/training') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}>
            TRAINING
          </Link>
          <a href="https://play.counterscripthq.com/data-hub" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">
            DATA HUB
          </a>
          <Link to="/gear" className={`font-headline text-sm tracking-widest transition ${isActive('/gear') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}>
            GEAR
          </Link>
          <Link to="/contact" className={`font-headline text-sm tracking-widest transition ${isActive('/contact') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}>
            CONTACT
          </Link>
        </div>

        {/* Mobile menu button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden p-2 hover:text-tactical-amber focus:outline-none text-white"
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {isMenuOpen ? (
              <path d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-tactical-black border-t border-tactical-border">
          <div className="px-4 py-3 space-y-2">
            <Link
              to="/"
              className={`block font-headline text-sm tracking-widest transition ${isActive('/') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              HOME
            </Link>
            <Link
              to="/training"
              className={`block font-headline text-sm tracking-widest transition ${isActive('/training') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              TRAINING
            </Link>
            <a
              href="https://play.counterscripthq.com/data-hub"
              className="block font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition"
              onClick={() => setIsMenuOpen(false)}
            >
              DATA HUB
            </a>
            <Link
              to="/gear"
              className={`block font-headline text-sm tracking-widest transition ${isActive('/gear') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              GEAR
            </Link>
            <Link
              to="/contact"
              className={`block font-headline text-sm tracking-widest transition ${isActive('/contact') ? 'text-tactical-amber' : 'text-white hover:text-tactical-amber'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              CONTACT
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
